/* EMPRICS site search v1.0 (28/10/26): one search for the whole site, opened from the header on every page.
   Results update as each character is typed (Shopify predictive search): products with photographs, collections,
   pages and articles. A product code (two letters and digits) also offers the code finder. Enter or "See all results"
   opens the full search page. Keys: "/" or Ctrl+K opens, Esc closes, arrow keys move through results. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ess]'); if (!root || root.__ess) return; root.__ess = true;
  var panel = root.querySelector('[data-ess-panel]'), input = root.querySelector('[data-ess-input]'),
      out = root.querySelector('[data-ess-results]'), form = root.querySelector('[data-ess-form]');
  var finder = root.dataset.finder || '/collections/lighting', timer = null, seq = 0, cache = {}, lastFocus = null;
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var strip = function (h) { var d = document.createElement('div'); d.innerHTML = h || ''; return (d.textContent || '').replace(/\s+/g, ' ').trim(); };
  var CODE = /^[A-Z]{2}\d{0,4}(\.[A-Z0-9.]*)?$/;

  function open() {
    lastFocus = document.activeElement;
    root.classList.add('is-open'); panel.hidden = false; document.documentElement.classList.add('ess-lock');
    setTimeout(function () { input.focus(); input.select(); }, 20);
    if (input.value) go();
  }
  function close() {
    root.classList.remove('is-open'); panel.hidden = true; document.documentElement.classList.remove('ess-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.querySelectorAll('[data-ess-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
  root.querySelectorAll('[data-ess-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    var t = e.target, typing = t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable);
    if (!panel.hidden && e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (panel.hidden && ((e.key === '/' && !typing) || ((e.ctrlKey || e.metaKey) && (e.key === 'k' || e.key === 'K')))) { e.preventDefault(); open(); }
  });

  input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(go, 120); });
  input.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var links = Array.prototype.slice.call(out.querySelectorAll('a')); if (!links.length) return;
    e.preventDefault(); (e.key === 'ArrowDown' ? links[0] : links[links.length - 1]).focus();
  });
  out.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var links = Array.prototype.slice.call(out.querySelectorAll('a')), i = links.indexOf(document.activeElement);
    if (i < 0) return; e.preventDefault();
    var n = i + (e.key === 'ArrowDown' ? 1 : -1);
    if (n < 0) input.focus(); else if (links[n]) links[n].focus();
  });
  form.addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });

  function go() {
    var q = input.value.trim();
    if (!q) { out.innerHTML = '<p class="ess__hint">Search products, product codes, collections, pages and articles.</p>'; return; }
    var mine = ++seq, url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,page,article&resources[limit]=8&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,tag,body,variants.sku';
    out.setAttribute('aria-busy', 'true');
    var done = function (j) {
      if (mine !== seq) return;
      out.removeAttribute('aria-busy');
      render(q, (j && j.resources && j.resources.results) || {});
    };
    if (cache[url]) return done(cache[url]);
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j) cache[url] = j; done(j); })
      .catch(function () { done(null); });
  }

  function render(q, r) {
    var html = '', Q = q.toUpperCase().replace(/\s+/g, '');
    if (CODE.test(Q) && Q.length >= 2) {
      html += '<div class="ess__group"><p class="ess__label">Product code</p><a class="ess__row ess__row--code" href="' + esc(finder) + '?sku=' + encodeURIComponent(Q) + '">' +
        '<span class="ess__codechip">' + esc(Q) + '</span><span class="ess__text"><strong>Look up ' + esc(Q) + ' in the code finder</strong><small>See what each position means and every matching code</small></span></a></div>';
    }
    var prods = r.products || [];
    if (prods.length) {
      html += '<div class="ess__group"><p class="ess__label">Products</p><div class="ess__grid">' + prods.map(function (p) {
        var img = p.featured_image && p.featured_image.url || p.image || '';
        if (img) img += (img.indexOf('?') < 0 ? '?' : '&') + 'width=160';
        var sub = [p.product_type, strip(p.body).replace(new RegExp('^' + (p.title || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*'), '').split(/Every option below/)[0]].filter(Boolean).join(' · ');
        return '<a class="ess__prod" href="' + esc(p.url) + '">' +
          (img ? '<span class="ess__img"><img src="' + esc(img) + '" alt="" loading="lazy" width="80" height="80"></span>' : '<span class="ess__img ess__img--none"></span>') +
          '<span class="ess__text"><strong>' + esc(p.title) + '</strong><small>' + esc(sub.slice(0, 90)) + '</small></span></a>';
      }).join('') + '</div></div>';
    }
    [['collections', 'Collections'], ['pages', 'Pages'], ['articles', 'Articles']].forEach(function (g) {
      var list = r[g[0]] || []; if (!list.length) return;
      html += '<div class="ess__group"><p class="ess__label">' + g[1] + '</p>' + list.slice(0, 5).map(function (x) {
        var sub = strip(x.body || x.summary_html || '').slice(0, 110);
        return '<a class="ess__row" href="' + esc(x.url) + '"><span class="ess__text"><strong>' + esc(x.title) + '</strong>' + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</span></a>';
      }).join('') + '</div>';
    });
    if (!html) html = '<p class="ess__hint">Nothing matches "' + esc(q) + '". Try a product code such as DL1001, a product type such as downlight, or call T: +44 (0) 330 174 4444.</p>';
    html += '<a class="ess__all" href="/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">See all results for "' + esc(q) + '"</a>';
    out.innerHTML = html;
  }
})();
